import { mapActions, mapGetters, mapState } from 'vuex';

import MspState from 'client/components/models/MspState';

const featureTrialModule = 'FeatureTrialModule';
const organizationsCollection = 'OrganizationsCollection';
const planModule = 'PlanModule';
const settingsModule = 'SettingsModule';
const subscriptionCollection = 'SubscriptionCollection';

export default {
  computed: {
    ...mapGetters(featureTrialModule, [
      'getFeatureUsage',
    ]),

    ...mapGetters(organizationsCollection, {
      getOrganizationDetails: 'getItemDetails',
    }),

    ...mapGetters(settingsModule, [
      'getIsCustomer',
      'hasBilling',
    ]),

    ...mapGetters(planModule, [
      'planHasFeature',
    ]),

    ...mapGetters(subscriptionCollection, {
      getSubscription: 'getItem',
    }),

    ...mapGetters('AddOnCollection', {
      getAddOn: 'getItem',
    }),

    ...mapState(settingsModule, [
      'orgId',
    ]),

    ...mapState(planModule, [
      'plan',
    ]),

    ...mapState({
      featureUsage(state) {
        return state[featureTrialModule].orgGrowthData.featureUsage;
      },
    }),

    activeFeatureUsage() {
      const activeTrials = {};
      const featureUsage = this.featureUsage || {};
      Object.keys(featureUsage).forEach(feature => {
        const featureState = featureUsage[feature];
        if (!!featureState.startDate && !featureState.endDate) {
          activeTrials[feature] = featureState;
        }
      });
      return activeTrials;
    },

    hasAnyFeatureTrials() {
      return !!this.activeFeatureUsage && Object.keys(this.activeFeatureUsage).length > 0;
    },

    showFeatureUsageSection() {
      return this.getIsCustomer
        && !MspState.isAnMspOrChild
        && this.hasAnyFeatureTrials;
    },
  },

  methods: {
    ...mapActions(subscriptionCollection, {
      fetchSubscriptions: 'fetchCollection',
    }),

    ...mapActions(planModule, [
      'fetchEntitledFeatureCodes',
    ]),

    ...mapActions(featureTrialModule, [
      'fetchFeatureUsage',
    ]),

    hasActiveFeatureTrial(feature) {
      const startedTrial = this.getTrialStartDate(feature);
      const endedTrial = this.getTrialEndDate(feature);
      return (!!startedTrial && !endedTrial);
    },

    hasEndedFeatureTrial(feature) {
      const endedTrial = this.getTrialEndDate(feature);
      return (!!endedTrial);
    },

    getTrialStartDate(feature) {
      return this.getFeatureUsage(feature) ? this.getFeatureUsage(feature).startDate : '';
    },

    getTrialEndDate(feature) {
      return this.getFeatureUsage(feature) ? this.getFeatureUsage(feature).endDate : '';
    },

    refreshTrialData(featureCode) {
      if (this.customerIsCandidate() && this.shouldCheckTrial()) {
        this.fetchFeatureUsage({ featureCode });
      }
    },

    customerIsCandidate() {
      return !MspState.isAnMspOrChild
        && this.getIsCustomer;
    },

    shouldCheckTrial(featureCode) {
      // Cut down on number of calls to feature usage.
      // Only check if there's a chance a trial would be started or ended.
      const hasFeature = this.planHasFeature(featureCode);
      const hasActiveTrial = this.hasActiveFeatureTrial(featureCode);
      return ((hasActiveTrial && hasFeature)
          || (!hasFeature && !hasActiveTrial));
    },
  },
};
